import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError, Observable, catchError } from "rxjs";
import { environment } from "src/app/environments/environment";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class AuthService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set("Content-Type", "application/json");

  base_url = environment.apiUrl;

  register(data: any): Observable<any> {
    // console.log(data);
    return this.http
      .post(this.base_url + `user/`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  signin(data: any): Observable<any> {
    // console.log(data);
    return this.http
      .post(this.base_url + `user/login/`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  getUserData(): Observable<any> {
    return this.http.get(this.base_url + "user/").pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  
  updatePassword(data: any): Observable<any> {
    // console.log(data);
    return this.http
      .post(this.base_url + `user/password/update`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  resetPassword(data: any): Observable<any> {
    // console.log(data);
    return this.http
      .post(this.base_url + `user/password/reset`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
}
